import { ApiService } from '../apiService'

export interface FirebaseTokenResponse {
  token: string
}

export type DevicePlatform = 'web' | 'ios' | 'android' | 'expo'

/**
 * Firebase realtime bridge endpoints. The backend mints a Firebase custom token derived from the
 * signed-in API user (so request.auth.uid == the app user id in Security Rules), and stores FCM
 * device tokens for background push.
 */
export const firebaseApi = {
  // Mint a Firebase custom token for signInWithCustomToken. 503 while Firebase is not configured.
  getToken: () => ApiService.get<FirebaseTokenResponse>('/api/Firebase/token'),

  // Register (upsert) an FCM/Expo push token for the current user.
  registerDeviceToken: (token: string, platform: DevicePlatform = 'web') =>
    ApiService.post<void>('/api/Firebase/device-tokens', { token, platform }),

  // Remove a device token (on logout / push-permission revoke).
  unregisterDeviceToken: (token: string) =>
    ApiService.delete<void>('/api/Firebase/device-tokens', { token }),
}
